import React, {useRef} from 'react';
import styles from './Footer.module.scss'
import cn from 'classnames';
import { connect } from 'react-redux';

const Footer = (props) => {

    const {
        checkData, groupObj,
        currentPage, setCurrentPage,
        station, emptyItems,
        result,
        filterData,
        footerSelection,
    } = props;

    const containerRef = useRef(null);
    const isData = groupObj && checkData && checkData(groupObj) && checkData(groupObj).length !== 0;

    const handlePaginationClick  = (clickCheck) => {
        if(station === 'expo'){
            return clickCheck === 'left' ? 
                isData && 
                    (currentPage > 0 && checkData(groupObj).length > 0 && setCurrentPage(state => state - 1)) :
                isData && 
                    (checkData(groupObj).length - 1 > 0 && currentPage < checkData(groupObj).length - 1 &&
                    setCurrentPage(state => state + 1))
        }
        else if(station === 'prep' || station === 'build'){
            return  clickCheck === 'left' ? 
                isData &&  
                    (currentPage > 0 && Object.keys(checkData(groupObj)).length > 0) && setCurrentPage((state) => state - 1) : 
                isData && 
                    (Object.keys(checkData(groupObj)).length > 1 && ((currentPage + 1) < Object.keys(checkData(groupObj)).length)) && setCurrentPage((state) => state + 1)
        }
    }

    const handleRightPageCount = () => {
        if(station === 'expo'){
            if(!isData){
                return 0
            }
            return (isData && (checkData(groupObj)).length - 1 - currentPage)

        }
        else if(station === 'prep' || station === 'build'){
            return (isData && (Object.keys(checkData(groupObj)).length - 1 - currentPage)) || 0
        }
    }

    const handleScrollLeft = () => {
        const container = containerRef.current;
        if (container) {
            container.scrollTo({
                left: container.scrollLeft - 200,
                behavior: 'smooth'
            })
        }
    }
    const handleScrollRight = () => {
        const container = containerRef.current;
        if (container) {
            container.scrollTo({
                left: container.scrollLeft + 200,
                behavior: 'smooth'
            })
        }
    }

    function divideArray(result) {
        const arr = result
        const middle = Math.ceil(arr.length / 2)
        const firstHalf = arr.slice(0, middle)
        const secondHalf = arr.slice(middle)
        return { firstHalf, secondHalf }
    }

    const containerScrollableWidth = containerRef.current?.scrollWidth - containerRef.current?.clientWidth;
    const scrollLeft = Math.floor(containerRef.current?.scrollLeft)
    const rightScrollDisable = (containerScrollableWidth <= (scrollLeft + 10)) || (containerScrollableWidth <= (scrollLeft - 10))
    const largeWindow = window.innerWidth > 1024;

    const generateTruncatedStr = (str) =>{
        if(str === str?.toUpperCase() && str?.length > 8){
            return largeWindow ? str: `${str?.substring(0,8)}..`
        }
        if(str?.length > 13){
            return `${str?.substring(0,largeWindow ? 13 : 10)}..`            
        }
        if(str?.length >= 10  && str?.length < 17){
            return largeWindow ? str : `${str?.substring(0,10)}..`
        }
        return str;
    }

    return (
        <div className={cn('position-absolute d-flex p-1 h-10 justify-content-between',styles.container)} style={{backgroundColor: props?.socketConnected ? '#FFFFFF' : '#E13737'}}>
            <div className={cn('d-flex justify-content-center align-items-center',styles.leftContainer)}>
                <button 
                    className={cn('d-flex justify-content-evenly align-items-center h-80',styles.button)}
                    style={{ backgroundColor: currentPage !== 0 && !emptyItems ? "#6A4DAE" : "#C6C6C6" }}
                    onClick={() =>
                        handlePaginationClick('left')
                    }
                    disabled = {currentPage === 0}
                >
                    <span className={cn(styles.buttonContent)}>
                        <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 320 512" className='fw-600' style={{fill: "#FFFF"}}><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>
                    </span>
                    <span className={cn('fw-600', styles.buttonContent)}>
                        {currentPage}
                    </span>
                </button>
            </div>
            <div className={cn('d-flex justify-content-center align-items-center p-0', styles.filtersDiv)}>
                {!emptyItems && <>
                    <div className={cn('m-2')}>
                        <svg onClick={handleScrollLeft} xmlns="http://www.w3.org/2000/svg" height="2em" viewBox="0 0 320 512" style={{ fill: scrollLeft !== 0 ? "#6A4DAE" : '#C6C6C6' }}><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" /></svg>
                    </div>
                    <div ref={containerRef} className={cn('row mx-1', styles.filtersBox)}>
                        <div className='d-flex col-12'>
                            {
                                divideArray(result).firstHalf.map((i) => (
                                    <div key={i.name}
                                        className={cn('font-weight-bold d-flex align-items-center justify-content-between mr-2 col-2 p-1', styles.filterItem)}
                                        onClick={() => { footerSelection(i); setCurrentPage(0) }}
                                        style={{ background: filterData?.[i.name] ?  "#C1D0FF" : "white"}}
                                    >
                                        
                                        <div className='d-flex align-items-center fs-10' style = {{paddingLeft: '1rem'}}>
                                            {generateTruncatedStr(i?.name)}
                                        </div>
                                        <div className={cn('mr-2 fs-10')}>
                                           {i.notSchedule + i.Schedule}
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                        <div className='d-flex col-12'>
                            {
                                divideArray(result).secondHalf.map((i) => (
                                    <div key={i.name}
                                        className={cn('font-weight-bold d-flex align-items-center justify-content-md-between mr-2 col-2 p-1', styles.filterItem)}
                                        onClick={() => { footerSelection(i); setCurrentPage(0) }}
                                        style={{ background: filterData?.[i.name] ?  "#C1D0FF" : "white"}}
                                    >
                                        <div className='d-flex align-items-center fs-10' style = {{paddingLeft: '1rem'}}>
                                            {generateTruncatedStr(i?.name)}
                                        </div>
                                        <div className={cn('mr-2 fs-10')}>
                                           {i.notSchedule + i.Schedule} 
                                        </div>
                                    </div>
                                ))
                            }
                        </div>

                    </div>

                    <div className={cn('m-2')}>
                        <svg onClick={handleScrollRight} xmlns="http://www.w3.org/2000/svg" height="2em" viewBox="0 0 320 512" style={{ fill: !rightScrollDisable ? "#6A4DAE" : '#C6C6C6' }}><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" /></svg>
                    </div>
                </>}
            </div>
            <div className={cn('d-flex justify-content-center align-items-center ',styles.rightContainer, styles.border)}>
                <button 
                    className={cn('h-80 d-flex justify-content-center align-items-center',styles.button)}
                    style={{ backgroundColor: handleRightPageCount() !== 0 && !emptyItems ? "#6A4DAE" :"#C6C6C6"}}
                    onClick={() =>handlePaginationClick('right')}
                >
                    <span className={cn('fw-600',styles.buttonContent)}>
                        {handleRightPageCount()}
                    </span> 
                    <span className={cn(styles.buttonContent)}>
                        <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 320 512" style={{fill: "#FFFF"}} className='ml-1 fw-600'><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>
                    </span>
                </button>
            </div>
        </div>
    )
}


const mapStateToProps = ({oauth}) => ({
    socketConnected: oauth.socketConnected,
})

export default connect(mapStateToProps, null)(Footer)